
(function(){
  function init(root){
    if(root.dataset.ekbReady==="1")return;root.dataset.ekbReady="1";
    var slides=Array.prototype.slice.call(root.querySelectorAll("[data-ekb-slide]"));
    var thumbs=Array.prototype.slice.call(root.querySelectorAll("[data-ekb-thumb]"));
    var index=0,stage=root.querySelector(".ekb-gallery-stage");
    var counter=root.querySelector("[data-ekb-counter]");
    function show(i){if(!slides.length)return;index=(i+slides.length)%slides.length;slides.forEach(function(n,j){n.classList.toggle("is-current",j===index);n.setAttribute("aria-hidden",j===index?"false":"true")});thumbs.forEach(function(n,j){n.classList.toggle("is-current",j===index);n.setAttribute("aria-pressed",j===index?"true":"false")});if(counter)counter.textContent=(index+1)+" / "+slides.length;}
    var prev=root.querySelector("[data-ekb-prev]"),next=root.querySelector("[data-ekb-next]");
    if(prev)prev.addEventListener("click",function(){show(index-1)});if(next)next.addEventListener("click",function(){show(index+1)});
    thumbs.forEach(function(n,j){n.addEventListener("click",function(){show(j)})});
    var startX=null;if(stage){stage.addEventListener("touchstart",function(e){startX=e.changedTouches[0].clientX},{passive:true});stage.addEventListener("touchend",function(e){if(startX===null)return;var d=e.changedTouches[0].clientX-startX;if(Math.abs(d)>48)show(index+(d<0?1:-1));startX=null},{passive:true})}
    // EKJ012_VARIANTS_2999_3999: each bundle adds one corresponding Shopify variant.
    var bundles=Array.prototype.slice.call(root.querySelectorAll("[data-ekb-bundle-select]"));
    var variantInput=root.querySelector('#ekb-form input[name="id"]');
    var qtyInput=root.querySelector("[data-ekb-form-qty]");
    var stickyLabel=root.querySelector("[data-ekb-sticky-qty]"),stickyPrice=root.querySelector("[data-ekb-sticky-price]"),stickySave=root.querySelector("[data-ekb-sticky-save]"),stickyCompare=root.querySelector("[data-ekb-sticky-compare]");
    var addBtn=root.querySelector("[data-ekb-cart]"),stickyBtn=root.querySelector('[data-ekb-sticky] button[type="submit"]');
    function selectBundle(button){
      var id=button.getAttribute("data-variant-id");
      var title=button.getAttribute("data-title")||"Complete Kit";
      var available=button.getAttribute("data-available")==="true";
      bundles.forEach(function(b){
        var selected=b===button;
        b.setAttribute("aria-pressed",String(selected));b.setAttribute("aria-expanded",String(selected));
        var card=b.closest("[data-ekb-bundle-card]");
        if(card){card.classList.toggle("is-chosen",selected);
          var details=card.querySelector("[data-ekb-bundle-items]");if(details)details.hidden=!selected;}
      });
      if(variantInput)variantInput.value=id;
      if(qtyInput)qtyInput.value="1";
      if(stickyLabel)stickyLabel.textContent=title;
      if(stickyPrice)stickyPrice.textContent=button.getAttribute("data-price")||"";
      // Read Shopify-localized compare-at text from the selected bundle, never infer an exchange rate.
      if(stickyCompare){
        var sourceCompare=button.querySelector(".ekb-single-compare");
        var compared=sourceCompare?sourceCompare.textContent.trim():"";
        stickyCompare.textContent=compared;
        stickyCompare.hidden=!compared;
      }
      // Mirror the selected bundle's savings; never show a savings amount without a compare-at anchor.
      if(stickySave){
        var sourceSave=button.querySelector(".ekb-bundle-saving");
        var savingText=sourceSave ? sourceSave.textContent.trim() : "";
        stickySave.textContent=savingText;
        stickySave.hidden=!savingText;
      }
      if(addBtn){addBtn.disabled=!available;var txt=Array.prototype.find.call(addBtn.childNodes,function(n){return n.nodeType===3});if(txt)txt.textContent=available?"Add to cart":"Currently unavailable";}
      if(stickyBtn)stickyBtn.disabled=!available;
    }
    bundles.forEach(function(b){b.addEventListener("click",function(){selectBundle(b)})});
    var defaultBundle=bundles.find(function(b){return b.getAttribute("aria-pressed")==="true"})||bundles[0];
    if(defaultBundle)selectBundle(defaultBundle);
    // EKJ012_SAMPLE_REVIEW_214_JS_20261031
    var sampleGrid=root.querySelector("[data-ekb-sample-grid]");
    if(sampleGrid){
      var sampleCards=Array.prototype.slice.call(sampleGrid.querySelectorAll("[data-ekb-sample-card]"));
      var sampleMore=root.querySelector("[data-ekb-sample-more]");
      var sampleVisible=root.querySelector("[data-ekb-sample-visible]");
      var sampleShown=3;
      function showSampleReviews(){
        sampleCards.forEach(function(card,i){card.hidden=i>=sampleShown});
        if(sampleVisible)sampleVisible.textContent=String(Math.min(sampleShown,sampleCards.length));
        if(sampleMore)sampleMore.hidden=sampleShown>=sampleCards.length;
      }
      if(sampleMore)sampleMore.addEventListener("click",function(){sampleShown+=3;showSampleReviews()});
      showSampleReviews();
    }
    // EKJ012_SIX_IMAGE_BEDTIME_GALLERY_V1
    var socialTrack=root.querySelector("[data-ekb-social-track]");
    if(socialTrack){
      var socialPhotos=Array.prototype.slice.call(socialTrack.querySelectorAll("[data-ekb-social-photo]"));
      var socialPrev=root.querySelector("[data-ekb-social-prev]"),socialNext=root.querySelector("[data-ekb-social-next]");
      var socialCounter=root.querySelector("[data-ekb-social-counter]");
      function socialVisibleCount(){
        if(!socialPhotos.length)return 0;
        var gap=parseFloat(window.getComputedStyle(socialTrack).gap)||0;
        var width=socialPhotos[0].getBoundingClientRect().width;
        return Math.max(1,Math.min(socialPhotos.length,Math.round((socialTrack.clientWidth+gap)/(width+gap))));
      }
      function socialCurrentFirst(){
        if(!socialPhotos.length)return 0;
        var gap=parseFloat(window.getComputedStyle(socialTrack).gap)||0;
        var span=socialPhotos[0].getBoundingClientRect().width+gap;
        return Math.max(0,Math.min(socialPhotos.length-1,Math.round(socialTrack.scrollLeft/Math.max(1,span))));
      }
      function socialUpdate(){
        var first=socialCurrentFirst(),visible=socialVisibleCount(),max=socialTrack.scrollWidth-socialTrack.clientWidth;
        if(socialCounter)socialCounter.textContent=(first+1)+(visible>1?"–"+Math.min(socialPhotos.length,first+visible):"")+" of "+socialPhotos.length;
        if(socialPrev)socialPrev.disabled=socialTrack.scrollLeft<=3;
        if(socialNext)socialNext.disabled=socialTrack.scrollLeft>=max-3;
      }
      function socialGo(direction){
        if(!socialPhotos.length)return;
        var gap=parseFloat(window.getComputedStyle(socialTrack).gap)||0;
        var one=socialPhotos[0].getBoundingClientRect().width+gap;
        var current=socialCurrentFirst();
        var increment=window.matchMedia("(max-width: 749px)").matches?1:3;
        var target=Math.max(0,Math.min(socialPhotos.length-1,current+direction*increment));
        socialTrack.scrollTo({left:target*one,behavior:"smooth"});
      }
      if(socialPrev)socialPrev.addEventListener("click",function(){socialGo(-1)});
      if(socialNext)socialNext.addEventListener("click",function(){socialGo(1)});
      socialTrack.addEventListener("scroll",socialUpdate,{passive:true});
      window.addEventListener("resize",socialUpdate,{passive:true});
      socialUpdate();
    }
    var sticky=root.querySelector("[data-ekb-sticky]"),cta=root.querySelector("[data-ekb-cart]");
    if(sticky&&cta&&"IntersectionObserver" in window){var observer=new IntersectionObserver(function(entries){var x=entries[0];sticky.classList.toggle("is-visible",!x.isIntersecting&&window.scrollY>550)},{threshold:.1});observer.observe(cta)}else if(sticky){window.addEventListener("scroll",function(){sticky.classList.toggle("is-visible",window.scrollY>850)},{passive:true})}
  }
  function start(){document.querySelectorAll("[data-ekb-page]").forEach(init)}
  if(document.readyState==="loading")document.addEventListener("DOMContentLoaded",start);else start();
  document.addEventListener("shopify:section:load",start);
})();
